<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form"
                    role="document"
                    style="width: 400px"
                >
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="ModalLabel">
                                Send Message to Client
                            </h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <form>
                                <div class="form-row">
                                    <div class="form-group">
                                        <label for="boat-notes">Message</label>
                                        <textarea
                                            style="height: auto;"
                                            v-model="message"
                                            class="form-control"
                                            rows="3"
                                        />
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    class="btn btn-primary ml-3"
                                    @click="sendMessage"
                                    :disabled="!message"
                                >
                                    Send
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-light"
                                    @click="closeModal"
                                >
                                    Cancel
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import DibbleApi from "../../../api";
import DibbleJS from "../../../dibble";

export default {
    name: "ModalAddNote",
    props: {
        orderId: {
            required: true,
            type: String
        }
    },
    data() {
        return {
            message: ""
        };
    },
    created() {},
    methods: {
        closeModal() {
            this.message = "";
            this.$emit("close");
        },
        sendMessage() {
            const params = {
                request: DibbleApi.api.sendSmsMessageToRentalOrderUser,
                order_id: this.orderId,
                text: this.message
            };
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, response => {
                DibbleJS.hideLoader();
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJS.toastSuccessMessage(response.message);
                    this.message = "";
                    this.$emit("send");
                } else {
                    DibbleJS.toastErrorMessage(response.message);
                }
            });
        }
    }
};
</script>

<style></style>
